import { QuoteBox } from './quote-box';
import './App.css';

function App() {
  return (
    <div className="App">
      <QuoteBox />
    </div>
  );
}

export default App;
